import React, { useContext, useState } from "react"
import ContentCard from "../../../../components/ContentCard"
import { Image, FrameCols, Menu, Name, Title, Description } from "./displays"
import Modal, { ModalContent, ModalHeader } from "../../../../components/Modal"
import FavoriteDelete from "./FavoriteDelete"
import FavoriteMove from "./FavoriteMove"
import { MENU_OPTION } from "./const"
import FavoriteShare from "./FavoriteShare"
import qs from "qs"
import { Mutation } from "react-apollo"
import { getRecentFavorites } from "../../queries"
import gql from "graphql-tag"
import { MyFavoriteModalContext } from "../../../../components/ResearchCanvas/MyfavoriteModal"
import AppContext from "../../../../shared/AppContext"

import "./style.scss"

const updateFavoriteLastAccessed = gql`
  mutation updateFavoriteLastAccessed($favoriteId: String!) {
    updateFavoritesFile(favoriteId: $favoriteId, setLastAccessedDate: true) {
      id
      response {
        payload
        message
      }
    }
  }
`
export const FAVORITE_TYPE = {
  TSIS: "TSIS",
  ETS: "ETS",
  SEARCH: "SEARCH",
  DATAREPORT: "DATAREPORT",
}

export function getFavoriteImage(type, imageURL) {
  switch (type) {
    case FAVORITE_TYPE.TSIS:
      return `https://${process.env.S3BUCKET}.s3.amazonaws.com/images/assets/tsis_model.png`
    case FAVORITE_TYPE.ETS:
      return `https://${process.env.S3BUCKET}.s3.amazonaws.com/images/assets/ets_model.png`
    case FAVORITE_TYPE.SEARCH:
      return `https://${process.env.S3BUCKET}.s3.amazonaws.com/images/assets/saved_search.png`
    case FAVORITE_TYPE.DATAREPORT:
      return `/static/images/data-report.png`
    default:
      if (imageURL) return imageURL
      return `https://${process.env.S3BUCKET}.s3.amazonaws.com/images/assets/image-icon.png`
  }
}

export default function FavoriteFile(props) {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [menuSelection, setMenuSelection] = useState()
  const closeMyFavoritesModal = useContext(MyFavoriteModalContext)
  const { trackEvent } = useContext(AppContext)

  const {
    className,
    hasMenu,
    favorite,
    trackingLocation,
    refetchQuery,
    descriptionLenght = 100,
    currentFolderId,
  } = props

  const {
    id: favoriteId,
    description,
    name,
    favoriteType,
    metadata,
    currentFolderName,
  } = favorite

  const getFavoriteLink = (favorite) => {
    const { slug, metadata } = favorite
    const params = {}

    if (metadata) {
      if (metadata.bookmark && metadata.bookmark.state) {
        params.bookmark = metadata.bookmark.state
      }

      if (metadata.searchKeyword) {
        params.keyword = metadata.searchKeyword
      }

      if (metadata.vendor) {
        params.vendor = metadata.vendor
      }

      if (metadata.sector) {
        params.sector = metadata.sector
      }

      if (metadata.reportType) {
        params.reportType = metadata.reportType
      }
    }

    return `${slug}?${qs.stringify(params)}`
  }

  const closeModal = () => {
    setIsModalOpen(false)
    setMenuSelection("")
  }

  const openModal = () => {
    setIsModalOpen(true)
  }

  const onMenuSelect = (data) => {
    switch (data.value) {
      case MENU_OPTION.SHARE:
        openModal()
        setMenuSelection(MENU_OPTION.SHARE)
        break

      case MENU_OPTION.MOVE:
        openModal()
        setMenuSelection(MENU_OPTION.MOVE)
        break

      case MENU_OPTION.DELETE:
        openModal()
        setMenuSelection(MENU_OPTION.DELETE)
        break

      default:
        break
    }
  }

  const handleClick = async (mutate) => {
    try {
      const { data } = await mutate()

      if (process.env.NODE_ENV !== "production") {
        console.log("setFavoriteLastAccessed response:", data)
      }

      trackEvent("Favorite Link Click", {
        location: trackingLocation,
        favoriteType: favorite.favoriteType,
        name: favorite.name,
        slug: favorite.slug,
      })

      if (closeMyFavoritesModal) {
        closeMyFavoritesModal()
      }
    } catch (err) {
      if (process.env.NODE_ENV !== "production") {
        console.log("an error occurred setting favorite lastAccessedDate", err)
      }
    }
  }

  const classNames = ["favorite-file-frame", className]
    .filter(Boolean)
    .join(" ")

  return (
    <Mutation
      mutation={updateFavoriteLastAccessed}
      variables={{ favoriteId: favorite.id }}
      refetchQueries={() => [{ query: getRecentFavorites }]}
    >
      {(mutate) => {
        return (
          <>
            <ContentCard
              className={classNames}
              style={{ padding: 0 }}
              data-cy="favorite-card"
            >
              <a
                href={getFavoriteLink(favorite)}
                onClick={() => handleClick(mutate)}
                className="favorites-link"
                style={{ padding: "1.5rem 4rem 1.5rem 1.5rem" }}
              >
                <FrameCols style={{ paddingRight: ".8rem" }}>
                  <Image
                    src={getFavoriteImage(favoriteType, metadata.imageURL)}
                  />
                </FrameCols>
                <FrameCols style={{ paddingRight: ".8rem" }}>
                  <Name text={name} length={60} />
                  <Title text={metadata.modelDisplayName} length={60} />
                  <Description length={descriptionLenght}>
                    {description}
                  </Description>
                </FrameCols>
              </a>
              {hasMenu && (
                <FrameCols>
                  <Menu
                    onSelect={onMenuSelect}
                    trackingLocation={trackingLocation}
                    name={name}
                    favoriteId={favoriteId}
                    description={description}
                  />
                </FrameCols>
              )}
            </ContentCard>
            {hasMenu && (
              <Modal
                isOpen={isModalOpen}
                close={closeModal}
                classes={["medium"]}
                allowBackdropClose={false}
              >
                <ModalContent>
                  <ModalHeader text={menuSelection + " favorite"} />
                  {MENU_OPTION.SHARE == menuSelection && (
                    <FavoriteShare
                      slug={getFavoriteLink(favorite)}
                      closeModal={closeModal}
                    />
                  )}
                  {MENU_OPTION.MOVE == menuSelection && (
                    <FavoriteMove
                      closeModal={closeModal}
                      favoriteName={favorite.name}
                      currentFolderName={currentFolderName}
                      favoriteId={favoriteId}
                      refetchQuery={refetchQuery}
                      currentFolderId={currentFolderId}
                      trackingLocation={trackingLocation}
                    />
                  )}
                  {MENU_OPTION.DELETE == menuSelection && (
                    <FavoriteDelete
                      name={name}
                      favoriteId={favoriteId}
                      closeModal={closeModal}
                      refetchQuery={refetchQuery}
                      trackingLocation={trackingLocation}
                    />
                  )}
                </ModalContent>
              </Modal>
            )}
          </>
        )
      }}
    </Mutation>
  )
}

FavoriteFile.defaultProps = {
  hasMenu: true,
  link: "",
  favorite: {},
}
